import React, { useEffect } from 'react';

import { Container, Row, Column } from 'components/Grid';

import MainLayout from 'layouts/MainLayout';

import flowSettings from 'settings/flow-settings';

import { useTranslation } from 'react-i18next';

import StyledTerms from './styles';

function Terms() {
  const { logo, appUrl } = flowSettings;
  const { t, i18n } = useTranslation();
  // mês/dia/ano
  const lastUpdate = new Date('04/30/2026').toLocaleDateString(
    i18n.language,
    { dateStyle: 'long' },
  );

  useEffect(() => {
    function sendHeightMessage() {
      const contentHeight = document.body.scrollHeight;

      window.parent.postMessage({ height: contentHeight }, '*');
    }

    window.addEventListener('load', sendHeightMessage);
    document.title = t('TITLE');

    return () => {
      window.removeEventListener('load', sendHeightMessage);
    };
  }, [t]);

  return (
    <MainLayout className="flow-site" logo={logo} appUrl={appUrl}>
      <StyledTerms>
        <Container className="mt-3 p-3">
          <Row justifyContent="center">
            <Column mobile="12" tablet="12" desktop="12" className="header">
              <h1 className="text-center mb-3 title">
                {t('TITLE')}
              </h1>
            </Column>
          </Row>
          <Row justifyContent="center">
            <Column mobile="12" tablet="12" desktop="12">
              <p className="text">
                {t('TEXT_1')}
              </p>

              <h3 className="topic">{t('TOPIC_1')}</h3>

              <p className="text">
                {t('TOPIC_1_TEXT')}
              </p>

              <h3 className="topic">{t('TOPIC_2')}</h3>

              <p className="text">
                {t('TOPIC_2_TEXT')}
              </p>

              <h3 className="topic">{t('TOPIC_3')}</h3>

              <p className="text">
                {t('TOPIC_3_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_3_TEXT_2')}
              </p>

              <p className="text">
                {t('TOPIC_3_TEXT_3')}
              </p>

              <p className="text">
                {t('TOPIC_3_TEXT_4')}
              </p>

              <p className="text">
                {t('TOPIC_3_TEXT_5')}
              </p>

              <p className="text">
                {t('TOPIC_3_TEXT_6')}
              </p>

              <h3 className="topic">
                {t('TOPIC_4')}
              </h3>

              <p className="text">
                {t('TOPIC_4_TEXT')}
              </p>

              <ul className="list">
                <li>
                  {t('TOPIC_4_LIST_1')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_2')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_3')}
                </li>
                <li>
                  {t('TOPIC_4_LIST_4')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_5')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_6')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_7')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_8')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_9')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_10')}
                </li>

                <li>
                  {t('TOPIC_4_LIST_11')}
                </li>
              </ul>

              <h3 className="topic">
                {t('TOPIC_5')}
              </h3>

              <p className="text">
                {t('TOPIC_5_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_5_TEXT_2')}
              </p>

              <ul className="list">
                <li>
                  {t('TOPIC_5_LIST_1')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_2')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_3')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_4')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_5')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_6')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_7')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_8')}
                </li>

                <li>
                  {t('TOPIC_5_LIST_9')}
                </li>
              </ul>

              <h3 className="topic">
                {t('TOPIC_6')}
              </h3>

              <p className="text">
                {t('TOPIC_6_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_6_TEXT_2')}
              </p>

              <p className="text">
                {t('TOPIC_6_TEXT_3')}
              </p>

              <h3 className="topic">
                {t('TOPIC_7')}
              </h3>

              <p className="text">
                {t('TOPIC_7_TEXT')}
              </p>

              <h3 className="topic">
                {t('TOPIC_8')}
              </h3>

              <p className="text">
                {t('TOPIC_8_TEXT')}
              </p>

              <ul className="list">
                <li>
                  {t('TOPIC_8_LIST_1')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_2')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_3')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_4')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_5')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_6')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_7')}
                </li>

                <li>
                  {t('TOPIC_8_LIST_8')}
                </li>
              </ul>

              <h3 className="topic">
                {t('TOPIC_9')}
              </h3>

              <p className="text">
                {t('TOPIC_9_TEXT')}
              </p>

              <h3 className="topic">{t('TOPIC_10')}</h3>

              <p className="text">
                {t('TOPIC_10_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_10_TEXT_2')}
              </p>

              <p className="text">
                {t('TOPIC_10_TEXT_3')}
              </p>

              <h3 className="topic">
                {t('TOPIC_11')}
              </h3>

              <p className="text">
                {t('TOPIC_11_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_11_TEXT_2')}
              </p>

              <p className="text">
                {t('TOPIC_11_TEXT_3')}
              </p>

              <h3 className="topic">{t('TOPIC_12')}</h3>

              <p className="text">
                {t('TOPIC_12_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_12_TEXT_2')}
              </p>

              <h3 className="topic">
                {t('TOPIC_13')}
              </h3>

              <p className="text">
                {t('TOPIC_13_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_13_TEXT_2')}
              </p>

              <p className="text">
                {t('TOPIC_13_TEXT_3')}
              </p>

              <h3 className="topic">
                {t('TOPIC_14')}
              </h3>

              <p className="text">
                {t('TOPIC_14_TEXT')}
              </p>

              <p className="text">
                {t('TOPIC_14_TEXT_2')}
              </p>

              <ul className="list">
                <li>{t('TOPIC_14_LIST_1')}</li>
                <li>{t('TOPIC_14_LIST_2')}</li>
                <li>{t('TOPIC_14_LIST_3')}</li>
                <li>{t('TOPIC_14_LIST_4')}</li>
                <li>{t('TOPIC_14_LIST_5')}</li>
              </ul>

              <p className="text">
                {t('TOPIC_14_TEXT_3')}
              </p>

              <p className="text">
                {t('TOPIC_14_TEXT_4')}
              </p>

              <p className="text">
                {t('TOPIC_14_TEXT_5')}
              </p>

              <p className="text">
                {`${t('LAST_UPDATE')} ${lastUpdate}`}
              </p>
            </Column>
          </Row>
        </Container>
      </StyledTerms>
    </MainLayout>
  );
}

export default Terms;
